if (!customElements.get('nuer-home-slider')) {
  class NuerHomeSlider extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('[data-slider-track]');
      this.slides = [...this.querySelectorAll('[data-slider-slide], .nuer-home-slider__slide')];
      this.dots = [...this.querySelectorAll('[data-slider-dot]')];
      if (!this.track || this.slides.length < 2) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.index = 0;
      this.userPaused = false;
      this.hovered = false;
      this.focused = false;
      this.visible = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.toggleButton = this.querySelector('[data-motion-toggle]');
      this.querySelector('[data-slider-prev]')?.addEventListener('click', () => this.go(this.index - 1), options);
      this.querySelector('[data-slider-next]')?.addEventListener('click', () => this.go(this.index + 1), options);
      this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.go(index), options));
      this.toggleButton?.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        this.updateControl();
      }, options);
      this.track.addEventListener('scroll', () => {
        if (!this.track.clientWidth) return;
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.setIndex(Math.max(0, Math.min(index, this.slides.length - 1)));
      }, { ...options, passive: true });
      this.addEventListener('mouseenter', () => { this.hovered = true; }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; }, options);
      this.addEventListener('focusin', () => { this.focused = true; }, options);
      this.addEventListener('focusout', (event) => { this.focused = this.contains(event.relatedTarget); }, options);
      this.reducedMotion.addEventListener('change', () => this.updateControl(), options);
      this.observer = new IntersectionObserver(([entry]) => { this.visible = entry.isIntersecting; });
      this.observer.observe(this);
      this.updateControl();
      if (!this.hasAttribute('data-manual')) this.timer = window.setInterval(() => {
        if (!this.userPaused && !this.hovered && !this.focused && this.visible && !this.reducedMotion.matches && !document.hidden) {
          this.go(this.index + 1);
        }
      }, 6000);
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.events?.abort();
      this.events = null;
      this.observer?.disconnect();
    }
    updateControl() {
      if (!this.toggleButton) return;
      this.toggleButton.hidden = this.reducedMotion.matches;
      this.toggleButton.setAttribute('aria-pressed', String(this.userPaused));
      this.toggleButton.textContent = this.userPaused ? this.toggleButton.dataset.resumeLabel : this.toggleButton.dataset.pauseLabel;
    }
    setIndex(index) {
      this.index = index;
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
    }
    go(index) {
      const target = (index + this.slides.length) % this.slides.length;
      this.setIndex(target);
      this.track.scrollTo({ left: this.track.clientWidth * target, behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
    }
  }
  customElements.define('nuer-home-slider', NuerHomeSlider);
}
